import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import reportReadAction from './reportRead.action.json' assert { type: 'json' }

const reportReadDefinition = defineReadAutoAction(reportReadAction, 'report')

export default reportReadDefinition
